<template>
  <div class="indexPage">
    <div class="swiperBox" id="swiper" :style="{ height: scrollerHeight }">
      <el-carousel>
        <el-carousel-item v-for="(item, index) in ppttrack" :key="index">
          <router-link
            :to="{
              path: '/PPThome',
              query: { tagId: item.id, tag: 2, itemName: item.name, type: 1 }
            }"
            v-if="item.type == 2"
          >
            <img
              class="bannImage"
              :ref="index === 0 ? 'imagBox' : null"
              :src="item.image"
              alt=""
              @click="addUrl(item)"
            />
          </router-link>
          <img
            v-else
            class="bannImage"
            :ref="index === 0 ? 'imagBox' : null"
            :src="item.image"
            alt=""
            @click="addUrl(item)"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="track_title hero-plain">
      <h3 class="t_h3">全国大学生职业规划大赛</h3>
      <h5 class="t_h5">筑/梦/青/春/志/在/四/方  &nbsp;&nbsp;规/划/启/航/职/引/未/来</h5>
    </div>

    <!-- <div class="albumBox" style="display: none">
      <div class="track_title">
        <h3 class="t_h3">三大赛道</h3>
        <h5 class="t_h5">THREE TYPES</h5>
      </div>
      <ul class="album_content clearfix">
        <li>
          <router-link :to="{ path: '/PPThome', query: { tagId: 1006, tag: 2, itemName: '高教主赛道', type: 1 } }">
            <img src="./../../assets/gaojiao.png" alt="" />
          </router-link>
        </li>
        <li>
          <router-link :to="{ path: '/PPThome', query: { tagId: 1008, tag: 2, itemName: '职教赛道', type: 1 } }">
            <img src="./../../assets/zhijiao.png" alt="" />
          </router-link>
        </li>
        <li>
          <router-link :to="{ path: '/PPThome', query: { tagId: 1007, tag: 2, itemName: '青红赛道', type: 1 } }">
            <img src="./../../assets/qinghong.png" alt="" />
          </router-link>
        </li>
      </ul>
    </div> -->
    <!-- 简历 -->
    <div class="album_PPT">
      <div class="track_title">
        <h3 class="t_h3">求职简历</h3>
        <h5 class="t_h5">RESUME</h5>
      </div>
      <!-- 选项卡 -->
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="item in myData"
          :key="item.id"
          :label="item.name"
          :name="item.id.toString()"
        >
          <div class="ppt_bOX">
            <section>
              <article
                class="ppt_post"
                v-for="item in newDataPage"
                :key="item.code"
              >
                <div class="ppt_inner" @click="jump(1, item, 4)">
                  <div class="ppt_media-pic">
                    <i class="ppt_tag-vip ppt_tag-vips"></i>
                    <img
                      :src="item.cover"
                      width="600"
                      height="400"
                      alt=""
                      class="wp-ppt_post-image"
                    />
                    <a class="ppt_post-cate">
                      <em class="ppt_tag-213"> 演示版 </em>
                    </a>
                  </div>
                  <div class="clearfix">
                    <p class="ppt_post-date fl">
                      <span
                        class=""
                        v-for="(citem, cindex) in item.tag.split(',')"
                        :key="citem.code"
                      >
                        <span class="ppt_mix_back_span">
                          {{ citem }}
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="ppt_media-body clearfix">
                    <a class="ppt_title fl" :title="item.name">
                      <span
                        class="ppt_title_span"
                        v-show="item.animation != 0"
                        >{{
                          item.animation == 1
                            ? "路演"
                            : item.animation == 2
                            ? "网评"
                            : ""
                        }}</span
                      >
                      {{ item.name }}
                    </a>
                    <p class="ppt_post-meta fr">
                      <em>
                        <i class="iconfont iconai-eye"></i>{{ item.pv }}
                      </em>
                      <em>
                        <i class="iconfont iconaixin"></i>{{ item.laud }}
                      </em>
                    </p>
                  </div>
                </div>
              </article>
            </section>
          </div>
          <!-- 分页 -->
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="totalItems"
            @current-change="newCurrent"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 就业能力展示 -->
    <div class="album_PPT">
      <div class="track_title">
        <h3 class="t_h3">就业能力展示</h3>
        <h5 class="t_h5">{{ "Employment Ability Display".toUpperCase() }}</h5>
      </div>
      <!-- 选项卡 -->
      <el-tabs v-model="activeName1" @tab-click="handleClickResume">
        <el-tab-pane
          v-for="item in resumeData"
          :key="item.id"
          :label="item.name"
          :name="item.id.toString()"
        >
          <div class="ppt_bOX">
            <section>
              <article
                class="ppt_post"
                v-for="item in resumeNewDataPage"
                :key="item.code"
              >
                <div class="ppt_inner" @click="jump(1, item, 6)">
                  <div class="ppt_media-pic">
                    <i class="ppt_tag-vip ppt_tag-vips"></i>
                    <img
                      :src="item.cover"
                      width="600"
                      height="400"
                      alt=""
                      class="wp-ppt_post-image"
                    />
                    <a class="ppt_post-cate">
                      <em class="ppt_tag-213"> </em>
                    </a>
                  </div>
                  <div class="clearfix">
                    <p class="ppt_post-date fl">
                      <span
                        class=""
                        v-for="(citem, cindex) in item.tag.split(',')"
                        :key="cindex"
                      >
                        <span class="ppt_mix_back_span">
                          {{ citem }}
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="ppt_media-body clearfix">
                    <a class="ppt_title fl" :title="item.name">
                      <span
                        class="ppt_title_span"
                        v-show="item.animation != 0"
                        >{{
                          item.animation == 1
                            ? "路演"
                            : item.animation == 2
                            ? "网评"
                            : ""
                        }}</span
                      >
                      {{ item.name }}
                    </a>
                    <p class="ppt_post-meta fr">
                      <em>
                        <i class="iconfont iconai-eye"></i>{{ item.pv }}
                      </em>
                      <em>
                        <i class="iconfont iconaixin"></i>{{ item.laud }}
                      </em>
                    </p>
                  </div>
                </div>
              </article>
            </section>
          </div>
          <!-- 分页 -->
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="resumeCurrentPage"
            :page-size="pageSize"
            :total="resumeTotalItems"
            @current-change="devenewCurrent"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 发展报告 -->

    <div class="album_PPT">
      <div class="track_title">
        <h3 class="t_h3">生涯发展报告</h3>
        <h5 class="t_h5">DEVEMOPEMNT REPORT</h5>
      </div>
      <!-- 选项卡 -->
      <el-tabs v-model="activeName2" @tab-click="ThreehandleClickResume">
        <el-tab-pane
          v-for="item in threeData"
          :key="item.id"
          :label="item.name"
          :name="item.id.toString()"
        >
          <div class="ppt_bOX">
            <section>
              <article
                class="ppt_post"
                v-for="item in threeNewDataPage"
                :key="item.code"
              >
                <div class="ppt_inner" @click="jump(1, item, 5)">
                  <div class="ppt_media-pic">
                    <i class="ppt_tag-vip ppt_tag-vips"></i>
                    <img
                      :src="item.cover"
                      width="600"
                      height="400"
                      alt=""
                      class="wp-ppt_post-image"
                    />
                    <a class="ppt_post-cate">
                      <em class="ppt_tag-213"> </em>
                    </a>
                  </div>
                  <div class="clearfix">
                    <p class="ppt_post-date fl">
                      <span
                        class=""
                        v-for="(citem, cindex) in item.tag.split(',')"
                        :key="cindex"
                      >
                        <span class="ppt_mix_back_span">
                          {{ citem }}
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="ppt_media-body clearfix">
                    <a class="ppt_title fl" :title="item.name">
                      <span
                        class="ppt_title_span"
                        v-show="item.animation != 0"
                        >{{
                          item.animation == 1
                            ? "路演"
                            : item.animation == 2
                            ? "网评"
                            : ""
                        }}</span
                      >
                      {{ item.name }}
                    </a>
                    <p class="ppt_post-meta fr">
                      <em>
                        <i class="iconfont iconai-eye"></i>{{ item.pv }}
                      </em>
                      <em>
                        <i class="iconfont iconaixin"></i>{{ item.laud }}
                      </em>
                    </p>
                  </div>
                </div>
              </article>
            </section>
          </div>
          <!-- 分页 -->
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="threeCurrentPage"
            :page-size="pageSize"
            :total="threeTotalItems"
            @current-change="threeDevenewCurrent"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 生涯展示 -->
    <div class="album_PPT">
      <div class="track_title">
        <h3 class="t_h3">生涯发展展示</h3>
        <h5 class="t_h5">
          {{ "Career Development Exhibition".toUpperCase() }}
        </h5>
      </div>
      <!-- 选项卡 -->
      <el-tabs v-model="activeName3" @tab-click="fourhandleClickResume">
        <el-tab-pane
          v-for="item in fourData"
          :key="item.id"
          :label="item.name"
          :name="item.id.toString()"
        >
          <div class="ppt_bOX">
            <section>
              <article
                class="ppt_post"
                v-for="item in fourNewDataPage"
                :key="item.code"
              >
                <div class="ppt_inner" @click="jump(1, item, 7)">
                  <div class="ppt_media-pic">
                    <i class="ppt_tag-vip ppt_tag-vips"></i>
                    <img
                      :src="item.cover"
                      width="600"
                      height="400"
                      alt=""
                      class="wp-ppt_post-image"
                    />
                    <a class="ppt_post-cate">
                      <em class="ppt_tag-213"> </em>
                    </a>
                  </div>
                  <div class="clearfix">
                    <p class="ppt_post-date fl">
                      <span
                        class=""
                        v-for="(citem, cindex) in item.tag.split(',')"
                        :key="cindex"
                      >
                        <span class="ppt_mix_back_span">
                          {{ citem }}
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="ppt_media-body clearfix">
                    <a class="ppt_title fl" :title="item.name">
                      <span
                        class="ppt_title_span"
                        v-show="item.animation != 0"
                        >{{
                          item.animation == 1
                            ? "路演"
                            : item.animation == 2
                            ? "网评"
                            : ""
                        }}</span
                      >
                      {{ item.name }}
                    </a>
                    <p class="ppt_post-meta fr">
                      <em>
                        <i class="iconfont iconai-eye"></i>{{ item.pv }}
                      </em>
                      <em>
                        <i class="iconfont iconaixin"></i>{{ item.laud }}
                      </em>
                    </p>
                  </div>
                </div>
              </article>
            </section>
          </div>
          <!-- 分页 -->
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="fourCurrentPage"
            :page-size="pageSize"
            :total="fourTotalItems"
            @current-change="fourDevenewCurrent"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 精品WORD推荐 -->
    <div class="diversions">
      <div class="banxin">
        <p class="banxin_title"></p>
        <div class="banxin_div">
          <vue-seamless-scroll
            :data="realData"
            :class-option="classOption1"
            ref="seamlessScroll"
            class="seamless-warp"
            style="padding-left: 30px"
          >
            <ul>
              <li
                class="bar_item fl"
                v-for="(item, index) in realData"
                :key="'r' + index"
                :data-index="index"
              >
                <div class="userImg">
                  <img :src="item.avatar" alt="" />
                </div>
                <div class="bar_detail" :title="item.content">
                  {{ item.content }}
                </div>
              </li>
            </ul>
          </vue-seamless-scroll>
          <vue-seamless-scroll
            :data="realData2"
            :class-option="classOption2"
            ref="seamlessScroll1"
            class="seamless-warp"
            style="padding-left: 60px"
          >
            <ul>
              <li
                class="bar_item fl"
                v-for="(items, index) in realData2"
                :key="'s' + index"
                :data-index="index"
              >
                <div class="userImg">
                  <img :src="items.avatar" alt="" />
                </div>
                <div class="bar_detail">
                  {{ items.content }}
                </div>
              </li>
            </ul>
          </vue-seamless-scroll>
          <vue-seamless-scroll
            :data="realData3"
            :class-option="classOption3"
            ref="seamlessScroll2"
            class="seamless-warp"
            style="padding-left: 90px"
          >
            <ul>
              <li
                class="bar_item fl"
                v-for="(item, index) in realData3"
                :key="'t' + index"
                :data-index="index"
              >
                <div class="userImg">
                  <img :src="item.avatar" alt="" />
                </div>
                <div class="bar_detail">
                  {{ item.content }}
                </div>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>

    <div class="itmentBox">
      <ul class="tment_ul clearfix">
        <li>
          <i class="iconfont iconbanquan"></i>
          <p class="decla_title">正版承诺</p>
          <p class="decla_intro">拒绝盗版，获设计师独家授权</p>
        </li>
        <li>
          <i class="iconfont iconbanquan1"></i>
          <p class="decla_title">版权保障 商用无忧</p>
          <p class="decla_intro">对全站所有模板均拥有商用授权</p>
        </li>
        <li class="last_item">
          <i class="iconfont icontiexinfuwu"></i>
          <p class="decla_title">全天候 贴心服务</p>
          <p class="decla_intro">
            发票支持，报销无忧<br />团队协作，院校会员可多人使用
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
// import nav from "../../store/moudels/nav";
export default {
  data() {
    return {
      isBooleResume: false,
      isBoole: false,
      isBoolthree: false,
      isBoolfour: false,
      newDataPage: [],
      // newPage:0,
      currentPage: 1, //当前页码
      pageSize: 8, //每页显示数量
      totalItems: 0, //总条目数
      realData: [],
      realData2: [],
      realData3: [],
      screenWidth: document.body.clientWidth,
      scrollerHeight: 678 + "px",
      ppttrack: [],
      artiList: [],
      wordList: [],
      myData: [], //首页数据
      activeName: "0",
      activeName1: "0",
      activeName2: "0",
      activeName3: "0",
      tagId: 0,
      myId: [],
      userSelectId: "",
      resumeData: [],
      resumeTagId: 0,
      resumeCurrentPage: 1,
      resumeTotalItems: 0,
      resumeNewDataPage: [],
      threeData: [],
      threeTagId: 0,
      threeCurrentPage: 1,
      threeTotalItems: 0,
      threeNewDataPage: [],
      fourData: [],
      fourTagId: 0,
      fourCurrentPage: 1,
      fourTotalItems: 0,
      fourNewDataPage: [],
      // 添加滚动位置记忆
      savedScrollPosition: 0
    };
  },
  computed: {
    classOption1() {
      return {
        step: 1.2, // 数值越大速度滚动越快
        limitMoveNum: 0, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1200 // 单步运动停止的时间(默认值1000ms)
      };
    },
    classOption2() {
      return {
        step: 1.2, // 数值越大速度滚动越快
        limitMoveNum: 0, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1200 // 单步运动停止的时间(默认值1000ms)
      };
    },
    classOption3() {
      return {
        step: 1.2, // 数值越大速度滚动越快
        limitMoveNum: 0, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1200 // 单步运动停止的时间(默认值1000ms)
      };
    },
    ...mapState(["nav"])
  },
  methods: {
    // logCurrentPage() {

    // },
    newCurrent(val) {
      this.currentPage = val;
      this.getSearchkey();
    },

    devenewCurrent(val) {
      this.resumeCurrentPage = val;
      this.getSearchResume();
    },
    threeDevenewCurrent(val) {
      this.threeCurrentPage = val;
      this.getSearchThree();
    },

    fourDevenewCurrent(val) {
      this.fourCurrentPage = val;
      this.getSearchFour();
    },
    // 获取2赛道首页数据
    getHome() {
      this.axios
        .indexVtwo({})
        .then(res => {
          const list = res.data.data || [];
          this.myData = [{ id: 0, name: "全部" }, ...list];
          if (this.myData.length > 0) {
            this.tagId = this.myData[0].id;
            this.getSearchkey();
          }
          // 数据加载完成后恢复滚动位置
          this.$nextTick(() => {
            this.restoreScrollPosition();
          });
        })
        .catch(err => {
          // 获取首页数据失败，静默处理
        });
    },
    //获得简历部分导航
    getresumenav() {
      this.axios
        .indexVResume({})
        .then(res => {
          const list = res.data.data || [];
          this.resumeData = [{ id: 0, name: "全部" }, ...list];
          if (this.resumeData.length > 0) {
            this.resumeTagId = this.resumeData[0].id;
            this.getSearchResume();
          }
          // 数据加载完成后恢复滚动位置
          this.$nextTick(() => {
            this.restoreScrollPosition();
          });
        })
        .catch(err => {
          // 获取简历导航失败，静默处理
        });
    },
    // 就业能力
    getIndexThree() {
      this.axios
        .indexVThree({})
        .then(res => {
          const list = res.data.data || [];
          this.threeData = [{ id: 0, name: "全部" }, ...list];
          if (this.threeData.length > 0) {
            this.threeTagId = this.threeData[0].id;
            this.getSearchThree();
          }
          // 数据加载完成后恢复滚动位置
          this.$nextTick(() => {
            this.restoreScrollPosition();
          });
        })
        .catch(err => {
          // 获取就业能力导航失败，静默处理
        });
    },
    getIndexFour() {
      this.axios
        .indexVFour({})
        .then(res => {
          const list = res.data.data || [];
          this.fourData = [{ id: 0, name: "全部" }, ...list];
          if (this.fourData.length > 0) {
            this.fourTagId = this.fourData[0].id;
            this.getSearchFour();
          }
          // 数据加载完成后恢复滚动位置
          this.$nextTick(() => {
            this.restoreScrollPosition();
          });
        })
        .catch(err => {
          // 获取生涯发展导航失败，静默处理
        });
    },
    getComment() {
      this.axios
        .indexComment({})
        .then(res => {
          if (res.data.code == 200) {
            this.realData = res.data.data.s1;
            this.$refs.seamlessScroll.reset();
            this.realData2 = res.data.data.s2;
            this.$refs.seamlessScroll1.reset();
            this.realData3 = res.data.data.s3;
            this.$refs.seamlessScroll2.reset();
          }
        })
        .catch(err => {
          // 获取评论数据失败，静默处理
        });
    },
    getSwipers() {
      this.axios
        .indexSwiper({})
        .then(res => {
          if (res.data.code == 200) {
            this.ppttrack = res.data.data;
            this.swiperBox();
          } else {
            this.ppttrack = [];
          }
        })
        .catch(err => {});
    },
    handleClick(tab, event) {
      this.currentPage = 1;
      this.tagId = this.myData[tab.index].id;
      const isAll = this.tagId === 0;
      const req = isAll
        ? this.axios.modulePage({ mark: 4, pageNum: 1, pageSize: this.pageSize, sort: "new" })
        : this.axios.searchkeyHome({ id: this.tagId, pageNum: 1 });
      req
        .then(res => {
          this.isBoole = false;
          this.totalItems = res.data.data.total; //总条目数
          this.newDataPage = res.data.data.records;
          this.$forceUpdate(); //强制刷新dom更新
        })
        .catch(err => {});
    },
    getSearchkey() {
      const isAll = this.tagId === 0;
      const req = isAll
        ? this.axios.modulePage({ mark: 4, pageNum: this.currentPage, pageSize: this.pageSize, sort: "new" })
        : this.axios.searchkeyHome({ id: this.tagId, pageNum: this.currentPage });
      req
        .then(res => {
          this.isBoole = false;
          this.totalItems = res.data.data.total; //总条目数
          this.newDataPage = res.data.data.records;
          this.$forceUpdate(); //强制刷新dom更新
        })
        .catch(err => {
          // 搜索失败，静默处理
        });
    },

    handleClickResume(tab, event) {
      this.resumeCurrentPage = 1;
      this.resumeTagId = this.resumeData[tab.index].id;
      const isAll = this.resumeTagId === 0;
      const req = isAll
        ? this.axios.modulePage({ mark: 6, pageNum: 1, pageSize: this.pageSize, sort: "new" })
        : this.axios.searchkeyResume({ id: this.resumeTagId, pageNum: 1 });
      req
        .then(res => {
          this.isBooleResume = false;
          this.resumeTotalItems = res.data.data.total; //总条目数
          this.resumeNewDataPage = res.data.data.records;
          this.$forceUpdate(); //强制刷新dom更新
        })
        .catch(err => {
          // console.log(err);
        });
    },

    ThreehandleClickResume(tab, event) {
      this.threeCurrentPage = 1;
      this.threeTagId = this.threeData[tab.index].id;
      const isAll = this.threeTagId === 0;
      const req = isAll
        ? this.axios.modulePage({ mark: 5, pageNum: 1, pageSize: this.pageSize, sort: "new" })
        : this.axios.searchkeyThree({ id: this.threeTagId, pageNum: 1 });
      req
        .then(res => {
          this.isBoolthree = false;
          this.threeTotalItems = res.data.data.total; //总条目数
          this.threeNewDataPage = res.data.data.records;
          this.$forceUpdate(); //强制刷新dom更新
        })
        .catch(err => {
          // console.log(err);
        });
    },

    fourhandleClickResume(tab, e) {
      this.fourCurrentPage = 1;
      this.fourTagId = this.fourData[tab.index].id;
      const isAll = this.fourTagId === 0;
      const req = isAll
        ? this.axios.modulePage({ mark: 7, pageNum: 1, pageSize: this.pageSize, sort: "new" })
        : this.axios.searchkeyFour({ id: this.fourTagId, pageNum: 1 });
      req
        .then(res => {
          this.isBoolfour = false;
          this.fourTotalItems = res.data.data.total; //总条目数
          this.fourNewDataPage = res.data.data.records;
          this.$forceUpdate(); //强制刷新dom更新
        })
        .catch(err => {
          // console.log(err);
        });
    },

    // 111
    getSearchResume() {
      const isAll = this.resumeTagId === 0;
      const req = isAll
        ? this.axios.modulePage({ mark: 6, pageNum: this.resumeCurrentPage, pageSize: this.pageSize, sort: "new" })
        : this.axios.searchkeyResume({ id: this.resumeTagId, pageNum: this.resumeCurrentPage });
      req
        .then(res => {
          this.isBooleResume = false;
          this.resumeTotalItems = res.data.data.total;
          this.resumeNewDataPage = res.data.data.records;
          this.$forceUpdate();
        })
        .catch(err => {
          // 获取简历数据失败，静默处理
        });
    },

    getSearchThree() {
      const isAll = this.threeTagId === 0;
      const req = isAll
        ? this.axios.modulePage({ mark: 5, pageNum: this.threeCurrentPage, pageSize: this.pageSize, sort: "new" })
        : this.axios.searchkeyThree({ id: this.threeTagId, pageNum: this.threeCurrentPage });
      req
        .then(res => {
          this.isBoole = false;
          this.threeTotalItems = res.data.data.total; //总条目数
          this.threeNewDataPage = res.data.data.records;
          this.$forceUpdate(); //强制刷新dom更新
        })
        .catch(err => {
          // 获取就业能力数据失败，静默处理
        });
    },

    getSearchFour() {
      const isAll = this.fourTagId === 0;
      const req = isAll
        ? this.axios.modulePage({ mark: 7, pageNum: this.fourCurrentPage, pageSize: this.pageSize, sort: "new" })
        : this.axios.searchkeyFour({ id: this.fourTagId, pageNum: this.fourCurrentPage });
      req
        .then(res => {
          this.isBoole = false;
          this.fourTotalItems = res.data.data.total; //总条目数
          this.fourNewDataPage = res.data.data.records;
          this.$forceUpdate(); //强制刷新dom更新
        })
        .catch(err => {
          // 获取生涯发展数据失败，静默处理
        });
    },

    //跳转至详情页
    jump(val, item, mark) {
      const query = { type: val, code: item.code };
      // 如果提供了mark参数，添加到查询参数中（用于职规赛等模块）
      if (mark) {
        query.mark = mark;
      }
      let link = this.$router.resolve({
        // name: "Detailspage",
        // zzh2
        name: "details",
        query: query
      });
      window.open(link.href, "_blank");
    },
    swiperBox() {
      this.$nextTick(() => {
        const img = this.$refs.imagBox;
        if (img && img[0] && img[0].offsetHeight) {
          this.scrollerHeight = img[0].offsetHeight + "px";
        }
      });
    },
    addUrl(item) {
      // console.log(item)
    },
    // 保存当前滚动位置
    saveScrollPosition() {
      this.savedScrollPosition =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
    },
    // 恢复滚动位置
    restoreScrollPosition() {
      if (this.savedScrollPosition > 0) {
        // 延迟恢复，确保页面内容已渲染
        setTimeout(() => {
          window.scrollTo({
            top: this.savedScrollPosition,
            behavior: "instant"
          });
        }, 100);
      }
    },
    ...mapMutations(["UP_BOOLE"])
  },
  watch: {
    screenWidth(val) {
      this.swiperBox();
    }
  },
  // 监听路由变化，保存滚动位置
  beforeRouteLeave(to, from, next) {
    this.saveScrollPosition();
    next();
  },
  // 监听路由进入，恢复滚动位置
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 在组件实例创建后恢复滚动位置
      vm.$nextTick(() => {
        vm.restoreScrollPosition();
      });
    });
  },
  // 组件被激活时恢复滚动位置
  activated() {
    this.$nextTick(() => {
      this.restoreScrollPosition();
    });
  },
  // 组件被停用时保存滚动位置
  deactivated() {
    this.saveScrollPosition();
  },
  // 组件销毁前保存滚动位置
  beforeDestroy() {
    this.saveScrollPosition();
  },
  created() {
    // console.log(nav.boole);
    // this.getJob();
    // this.getapp();
  },
  async mounted() {
    // 先并行获取所有导航/基础数据
    await this.getSwipers();
    await this.getComment();

    // 并行获取所有依赖 id 的数据
    await Promise.all([
      this.getHome(),
      this.getresumenav(),
      this.getIndexThree(),
      this.getIndexFour()
    ]);

    // 等待数据准备好后再发起依赖 id 的请求
    // if (this.myData.length > 0) {
    //   this.tagId = this.myData[0].id;
    //   await this.getSearchkey();
    // }
    // if (this.resumeData.length > 0) {
    //   this.resumeTagId = this.resumeData[0].id;
    //   await this.getSearchResume();
    // }
    // if (this.threeData.length > 0) {
    //   this.threeTagId = this.threeData[0].id;
    //   await this.getSearchThree();
    // }
    // if (this.fourData.length > 0) {
    //   this.fourTagId = this.fourData[0].id;
    //   await this.getSearchFour();
    // }

    await this.UP_BOOLE();

    this.$nextTick(() => {
      setTimeout(() => {
        this.swiperBox();
        // 恢复滚动位置
        this.restoreScrollPosition();
      }, 1000);
    });
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  }
};
</script>
<style scoped>
@import "./../../styles/Page/indexPage.css";
</style>
<style>
/* 页头标题（纯色加强版） */
.hero-plain {
  margin: 28px auto 20px;
  text-align: center;
}
.hero-plain .t_h3 {
  font-size: 34px;
  line-height: 1.25;
  font-weight: 900;
  color: #222;
  letter-spacing: 1px;
}
.hero-plain .t_h3::after {
  content: "";
  display: block;
  width: 80px;
  height: 4px;
  background: #2b6cff;
  margin: 10px auto 0;
  border-radius: 2px;
}
.hero-plain .t_h5 {
  margin-top: 8px;
  font-size: 14px;
  line-height: 1.2;
  color: #31ADF7;
  letter-spacing: 1.5px;
}
/* 选项卡 */
.el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 分页 */
.el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}
.seamless-warp {
  height: 80px;
  margin-bottom: 17px;
  overflow: hidden;
}
.swiperBox .el-carousel__indicators {
  opacity: 0;
}
.swiperBox .el-carousel {
  width: 100%;
  overflow: hidden;
  height: 100%;
}
.swiperBox .el-carousel__container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
